import { render, staticRenderFns } from "./cashBackConfig.vue?vue&type=template&id=107c7ff7&"
import script from "./cashBackConfig.vue?vue&type=script&lang=js&"
export * from "./cashBackConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports